import React from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../redux/features/auth/authSlice";

function useAuthCheck() {
  const [isAuth, setIsAuth] = React.useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    const { accessToken, user } =
      JSON.parse(localStorage.getItem("auth")) || {};

    if (accessToken && user) {
      dispatch(
        loginUser({
          accessToken,
          user,
        })
      );
    }
    setIsAuth(true);
  }, [dispatch, setIsAuth]);
  return isAuth;
}

export default useAuthCheck;
